/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import { USER_STATUS_TYPES } from '../../../constants/props';

import Hover from './Hover';

import styles from './index.styl';

const StatusIndicator = ({ active, status }) => {
  const styleNames = classNames(
    'root',
    { [`root--${status}`]: status },
    { 'root--active': active },
  );

  return (
    <div styleName={styleNames}>
      <span styleName="indicator" />
      <Hover {...{ status }} />
    </div>
  );
};

StatusIndicator.propTypes = {
  active: PropTypes.bool,
  status: PropTypes.oneOf(USER_STATUS_TYPES),
};

export default CSSModules(StatusIndicator, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/StatusIndicator/index.jsx